import ConversionUserInfoChartActions from '../../actions/ConversionUserInfoChartActions';
import store from "../../stores/redux";

export const actions = {
    initConversionUserInfoChart() {
        let conversionId = store.getState().conversions.item.ConversionId;
        ConversionUserInfoChartActions.getConversionUserInfo(
            {id: conversionId}
        );
    }
};
